var _ellipse, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 154,
    viewBox: "0 0 148 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_163_413)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.8583,
    cy: 72.6519,
    rx: 58.8583,
    ry: 61.6519,
    fill: "#FF7C04"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_163_413",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 28,
    width: 64,
    height: 89
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.39 28.6148H42.3271V116.689H105.39V28.6148Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_163_413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.0578 97.8822V50.7452C47.0578 47.3399 49.6933 44.5793 52.9443 44.5793H94.1502C97.4012 44.5793 100.037 47.3399 100.037 50.7452V81.5749C100.037 84.9804 97.4012 87.7408 94.1502 87.7408H61.6601C59.8718 87.7408 58.1806 88.5923 57.0635 90.0549L50.2027 99.0378C49.1599 100.403 47.0578 99.6308 47.0578 97.8822Z",
    stroke: "white",
    strokeWidth: 6.35
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_163_413",
    x: 0,
    y: 0,
    width: 147.717,
    height: 153.304,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_163_413"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_163_413",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbox);
export default __webpack_public_path__ + "static/media/chatbox.f2592c7c6107caa96d6e24f3c5945637.svg";
export { ForwardRef as ReactComponent };